"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrderPriceToDisplay = exports.getFuturesOrderPriceToDisplay = void 0;
var _numberFormatter = require("./numberFormatter");
var getOrderPriceToDisplay = exports.getOrderPriceToDisplay = function getOrderPriceToDisplay(order, decimalPlaces) {
  return order.trailingPrice ? order.trailingPrice : order.Price ? (0, _numberFormatter.formatNumberToLocale)(order.Price, decimalPlaces || order.Price.symbol) : '';
};
var getFuturesOrderPriceToDisplay = exports.getFuturesOrderPriceToDisplay = function getFuturesOrderPriceToDisplay(order, decimalPlaces) {
  return order.trailingPrice ? order.trailingPrice : order.Price != null ? (0, _numberFormatter.formatNumberToLocale)(order.Price, decimalPlaces || order.Price.symbol) : '';
};